export const PAGE_HOME = "/";
export const PAGE_COPILOT_MESSAGE = "/copilotmessage";
export const PAGE_LOGIN = "/login";
export const PAGE_FORGOT_PASSWORD = "/forgot-password";
export const PAGE_CHANGE_PASSWORD = "/change-password";
export const PAGE_LOADING = "/loading";
export const PAGE_RESET_PASSWORD_CONFIRM = "/login/confirm-password-recovery";
export const PAGE_EXPIRED_PASSWORD = "/expired-password";
